import { render, staticRenderFns } from "./PublicationList.vue?vue&type=template&id=12ab4bb8&scoped=true&"
import script from "./PublicationList.vue?vue&type=script&lang=js&"
export * from "./PublicationList.vue?vue&type=script&lang=js&"
import style0 from "./PublicationList.vue?vue&type=style&index=0&id=12ab4bb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab4bb8",
  null
  
)

export default component.exports